import script from "./associateTags.vue?vue&type=script&setup=true&lang=js"
export * from "./associateTags.vue?vue&type=script&setup=true&lang=js"

import "./associateTags.vue?vue&type=style&index=0&id=1eef9ea6&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eef9ea6"]])

export default __exports__